import React, { useState } from "react";
import {
  UserNoticeContainer,
  HeaderContainer,
  ContentContainer,
  NotificationContent,
} from "./SurveyPrompt.styled";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";
import PropTypes from "prop-types";

const SurveyPrompt = ({
  handleClose,
  classIdentity,
  handleEncriptParametersSurvey,
  survey,
}) => {
  const [user] = useState(getStateLoginComplete());

  const userInfo = {
    "blue-card":
      "just a gentle reminder that you have 7 days to complete your survey.",
    "blue-card-3":
      "just a gentle reminder that you have 3 days to complete your survey.",
    "yellow-card":
      "just a gentle reminder that you have 1 day to complete your survey.",
    "red-card":
      "just a gentle reminder that you have to complete your survey today.",
  };

  return (
    <NotificationContent onClick={() => {
      handleClose(survey?.idSurvey);
      handleEncriptParametersSurvey(survey?.idSurvey, true, undefined);
    }}
      className="container-notifi">
      <UserNoticeContainer classIdentity={classIdentity}>
        <HeaderContainer>
          {survey?.surveyName}
        </HeaderContainer>
        <ContentContainer>
          <p> Hi {user?.displayName ?? "User"}, {userInfo[classIdentity]}</p>
        </ContentContainer>
      </UserNoticeContainer>
    </NotificationContent>
  );
};

export default SurveyPrompt;

SurveyPrompt.propTypes = {
  handleClose: PropTypes.func,
  classIdentity: PropTypes.string,
  survey: PropTypes.object,
  handleEncriptParametersSurvey: PropTypes.func,
}